
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface ProfileErrorProps {
  error: string | null;
}

export const ProfileError = ({ error }: ProfileErrorProps) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-2">Creator Not Found</h1>
        <p className="text-muted-foreground mb-6">
          {error || "The creator you're looking for doesn't exist or has been removed."}
        </p>
        <Link to="/">
          <Button>Return to Homepage</Button>
        </Link>
      </div>
    </div>
  );
};
